import React from 'react';
import {Fade} from 'react-awesome-reveal';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';
import SectionTitle from './SectionTitle';
import useReducedMotion from '../hooks/useReducedMotion';

const STEPS = ['step1', 'step2', 'step3', 'step4'];

/**
 * «Как проходит обучение» — четыре шага от заявки до закрывающих документов.
 * Секция снимает главный процедурный вопрос корпоративного заказчика:
 * как это оформляется и что он получит на руки.
 */
const HowItWorks = ({tone = 'alt'}) => {
    const reduced = useReducedMotion();

    return (
        // tone задаёт фон: две секции одного цвета подряд сливаются в одно длинное поле,
        // поэтому страница сама решает, светлой или серой быть этому блоку
        <section className={tone === 'light' ? classes.section : classes.sectionAlt}>
            <div className={classes.container}>
                <SectionTitle id="coursesPage.how.title" className={classes.sectionHead}/>
                <div className={classes.steps}>
                    {STEPS.map((key, i) => {
                        const step = (
                            <div className={classes.step}>
                                <span className={classes.stepBadge}>{String(i + 1).padStart(2, '0')}</span>
                                <h3 className={classes.stepTitle}>
                                    <IntlMessage id={`coursesPage.how.${key}.title`}/>
                                </h3>
                                <p className={classes.stepText}>
                                    <IntlMessage id={`coursesPage.how.${key}.text`}/>
                                </p>
                            </div>
                        );
                        return reduced
                            ? <React.Fragment key={key}>{step}</React.Fragment>
                            : (
                                <Fade triggerOnce direction="up" duration={500} delay={i * 60} key={key}>
                                    {step}
                                </Fade>
                            );
                    })}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
